export const TAWK_READY_EVENT = 'tawk-ready';
export const TAWK_MOBILE_MEDIA_QUERY = '(max-width: 920px)';
export const TAWK_BOTTOM_OFFSET = 55;
export const TAWK_SIDE_OFFSET = 16;
export const TAWK_Z_INDEX = 1_000_000;
const TAWK_REPOSITION_DELAYS_MS = [50, 200, 500, 1500];

const TAWK_WIDGET_SELECTORS = [
  '#tawk-bubble-container',
  '.tawk-min-container',
  '.tawk-button',
];

export function isTawkMobileViewport(): boolean {
  return window.matchMedia(TAWK_MOBILE_MEDIA_QUERY).matches;
}

export function getTawkCustomStyle() {
  return {
    visibility: {
      desktop: {
        position: 'br' as const,
        xOffset: 20,
        yOffset: TAWK_BOTTOM_OFFSET,
      },
      mobile: {
        position: 'bl' as const,
        xOffset: TAWK_SIDE_OFFSET,
        yOffset: TAWK_BOTTOM_OFFSET,
      },
    },
    zIndex: TAWK_Z_INDEX,
  };
}

/** Pin widget to bottom-left on mobile (desktop uses Tawk customStyle 'br'). */
function pinWidget(el: HTMLElement): void {
  el.style.setProperty('bottom', `${TAWK_BOTTOM_OFFSET}px`, 'important');
  el.style.setProperty('left', `${TAWK_SIDE_OFFSET}px`, 'important');
  el.style.setProperty('right', 'auto', 'important');
}

/** Force position after Tawk injects inline styles (SPA route changes). */
export function applyTawkPosition(): void {
  if (!isTawkMobileViewport()) return;

  const mobileStyle = window.Tawk_API?.customStyle?.visibility?.mobile;
  if (mobileStyle) {
    mobileStyle.position = 'bl';
    mobileStyle.xOffset = TAWK_SIDE_OFFSET;
    mobileStyle.yOffset = TAWK_BOTTOM_OFFSET;
  }

  TAWK_WIDGET_SELECTORS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((node) => {
      pinWidget(node as HTMLElement);
    });
  });

  document.querySelectorAll('div[class*="tawk"]').forEach((node) => {
    const el = node as HTMLElement;
    if (getComputedStyle(el).position === 'fixed') {
      pinWidget(el);
    }
  });
}

/** Re-apply position on load and after Tawk rewrites inline styles. */
export function scheduleTawkReposition(): void {
  applyTawkPosition();
  TAWK_REPOSITION_DELAYS_MS.forEach((delay) => {
    window.setTimeout(applyTawkPosition, delay);
  });
}
